import { render, staticRenderFns } from "./FaqInleners.vue?vue&type=template&id=224a51d6&"
import script from "./FaqInleners.vue?vue&type=script&lang=ts&"
export * from "./FaqInleners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports